import React from "react";
import "./Main_heading_holder.css";

function Main_heading_holder({
  heading,
  spanHeading,
  subHeading,
  headingColor,
  spanHeadingColor,
  headingType = "h2",
}) {
  const HeadingTag = headingType;

  return (
    <>
      <section className="Main_heading_holder">
        <HeadingTag
          style={{ color: headingColor }}
          className="main_section_heading_text"
        >
          {heading}{" "}
          <span style={{ color: spanHeadingColor }}>{spanHeading}</span>
        </HeadingTag>
        {subHeading && <p className="subtext">{subHeading}</p>}
      </section>
    </>
  );
}

export default Main_heading_holder;
